import { MigrationLedgerPanel } from '@/components/admin/MigrationLedgerPanel';

/**
 * 계정 이전 원장 — 활성 verse 의 `migrationRequests` 를 조회한다. 방향에 따라 출발 verse 가
 * 바뀌므로(web2→web3 땐 web2, web3→web2 땐 web3) 양쪽 verse 에서 연다.
 */
export default function MigrationPage() {
  return (
    <section className="flex flex-col gap-4">
      <header>
        <h2 className="text-2xl font-semibold tracking-tight">계정 이전 원장</h2>
        <p className="text-sm text-muted-foreground">
          이 verse 에서 출발한 계정 이전 신청 목록. 상태·대상 주소·실패 사유를 확인합니다.
        </p>
      </header>
      <MigrationLedgerPanel />
    </section>
  );
}
